import type { ReactNode } from 'react';
import { WorkingSheet } from './WorkingSheet';
interface Props {
  status: string;
  onClose: () => void;
  buttonClass: string;
  children: ReactNode;
}
export function WorkingPageManagement({ status, onClose, children }: Props) {
  return (
    <WorkingSheet
      title="My working · this question"
      label="Manage current working"
      onClose={onClose}
    >
      <p className="my-3 text-xs leading-relaxed text-slate2">
        Your working stays with this question. Find saved pages in My working. Export a copy from
        More tools.
      </p>
      <p role="status" className="mb-3 text-sm font-bold">
        {status}
      </p>
      {children}
    </WorkingSheet>
  );
}
